<template>
  <div>
    <div class="row">
      <div class="col-12 text-center" style="pointer-events: none;">
        <iframe
          :src="videoSrc"
          width="150"
          height="100"
          frameborder="0"
          allow=""
        >
        </iframe>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-logo text-center">
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 subtitle body"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoCard",
  props: ["title", "videoSrc"],
};
</script>

<style lang="scss" scoped>
.body {
  font-size: 12px;
}
</style>
